import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useBingeWatchingOverlay } from '@24i/player-ui';
import TertiaryButton from '@24i/nxg-sdk-gluons/src/components/buttons/TertiaryButton';
import { ButtonsContainer, buttonContainerStyle, closeButtonContainerStyle } from './styled';
export const BingeWatchingOverlay = ({ playerInstance, asset, hasNextEpisode, onGoToNextEpisode, }) => {
    const { t } = useTranslation(['sott']);
    const { isOpen, isDismissed, remainingTime, onHide, onNext } = useBingeWatchingOverlay({
        playerInstance,
        asset,
        hasNextEpisode,
        onGoToNextEpisode,
    });
    const hide = useCallback((event = null) => {
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        onHide();
    }, [onHide]);
    if ((!isOpen && !isDismissed) || remainingTime === 0) {
        return null;
    }
    return (React.createElement(ButtonsContainer, null,
        !isDismissed && (React.createElement(TertiaryButton, { iconName: "onButtonTertiary-close", iconSize: 22, additionalContainerStyles: closeButtonContainerStyle, onPress: hide })),
        React.createElement(TertiaryButton, { title: isDismissed
                ? t('player.nextEpisode')
                : t('player.bingeWatch', { count: remainingTime }), iconName: "onButtonTertiary-skipNext", iconSize: 22, additionalContainerStyles: buttonContainerStyle, onPress: onNext })));
};
BingeWatchingOverlay.displayName = 'BingeWatchingOverlay';
//# sourceMappingURL=index.js.map